import classNames from 'classnames';
import styles from './BlurbCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { formatDate } from '../../../../../helpers/date';

export interface BlurbCardProps {
	className?: string;
	heading?: string;
	link: {
		url: string;
		target?: string;
		name?: string;
	};
	kicker?: string;
	text?: string;
	date?: Date;
	type?: '' | 'bordered';
}

export const UI_BlurbCard = ({ link, className, heading, kicker, text, date, type }: BlurbCardProps) => {
	return (
		<div className={classNames(styles.BlurbCard, styles[`BlurbCard___${type}`], className)}>
			<UI_Link className={styles.BlurbCard_link} title={link?.name} {...link}>
				<div className={styles.BlurbCard_textbox}>
					{kicker && <div className={styles.BlurbCard_kicker}>{kicker}</div>}
					{heading && (
						<UI_Heading headingLevel="h3" style="default" className={styles.BlurbCard_heading}>
							{heading}
						</UI_Heading>
					)}
					{date && <div className={styles.BlurbCard_date}>{formatDate(date, 'dd.mm.yyyy')}</div>}
					<div className={styles.BlurbCard_text} dangerouslySetInnerHTML={{ __html: text }}></div>
					{link && <div className={styles.BlurbCard_citation}>{link?.url?.toString()}</div>}
				</div>
			</UI_Link>
		</div>
	);
};
